import { createSlice } from '@reduxjs/toolkit';
import * as reducers from './reducers';
import { Breakpoints } from './types';
var width = window.innerWidth;
var initialState = {
    isMobileOrSmaller: width < Breakpoints.TABLET,
    isTabletOrSmaller: width < Breakpoints.LAPTOP,
    isLaptopOrSmaller: width < Breakpoints.DESKTOP,
    currentWidth: width,
};
var breakpointsSlice = createSlice({
    name: 'breakpoints',
    initialState: initialState,
    reducers: reducers,
});
export var reducer = breakpointsSlice.reducer, updateBreakpoints = breakpointsSlice.actions.updateBreakpoints;
